import { render, staticRenderFns } from "./AttendencePlace.vue?vue&type=template&id=53e33c8b&scoped=true"
import script from "./AttendencePlace.vue?vue&type=script&lang=js"
export * from "./AttendencePlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e33c8b",
  null
  
)

export default component.exports